import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import editorFormMixin from 'next/javascripts/mixins/editor-form-mixin';
import editorDraftMixin from 'next/javascripts/mixins/editor-draft-mixin';
import 'next/stylesheets/components/comment-form.scss';

Component('tr-comment-form', {
  mixins: [eventListenerMixin, editorFormMixin, editorDraftMixin],

  properties: {
    visible: {
      type: Boolean,
      default: false,
      observer() {
        if (this.visible) {
          if (this.editor.editorReady) {
            this.editor.focus();
          } else {
            this.editor.initEditor();
          }
        }
      },
    },

    removeAfterCancel: {
      type: Boolean,
      default: false,
    },
  },

  connected() {
    this.editor = this.querySelector('.comment-editor');

    this.listenTo(this.editor, {
      'tr-editor:editorReady': () => {
        if (this.content) {
          this.editor.setData(this.content);
          this.editor.focus();
        }
      },
    });
    this.listenTo(this.querySelector('.cancel-button'), 'click', this.handleFormCancel.bind(this));

    $(this).on('ajax:beforeSend', 'form', this.beforeFormSubmit.bind(this));
  },

  disconnected() {
    this.stopListening();
  },

  setContent(content) {
    if (!this.editor) return;

    if (this.editor.editorReady) {
      this.editor.setData(content);
    } else {
      this.content = content;
    }
  },

  beforeFormSubmit(event, xhr, settings) {
    const attachIds = this.editor.getAttachIds();
    // eslint-disable-next-line no-param-reassign
    settings.data += `&attach_guids=${attachIds.join(',')}`;
  },

  handleFormCancel() {
    const cancel = this.namespacedTrigger('cancel');
    if (cancel) this.cancel();
  },

  cancel() {
    if (this.removeAfterCancel) {
      this.parentNode.removeChild(this);
    } else {
      this.visible = false;
    }
  },
});
